import { listsV2 } from '@ecosystem/newron-design-system';

/*
 * Common cell configuration used across various tables.
 * This configuration can be extended or modified as needed.
 */
export const commonTableCellConfig: listsV2.CellConfig = {
  hasBottomBorder: false,
  hasRightBorder: false,
};
